import { FavoriteFieldsQueryOperationQuery as FavoriteFieldsQueryOperation } from 'core/graphql';
import { FAVORITE_FIELDS_QUERY } from 'shared/components/internal/FavoriteField';
import { parseFavoriteRecordFields } from 'shared/components/internal/FavoriteFields';
import { useQuery } from 'shared/hooks';

import { RecordType } from '..';

export const useFavoriteFields = (record: RecordType) => {
  const { data } = useQuery<FavoriteFieldsQueryOperation>(
    FAVORITE_FIELDS_QUERY
  );

  const favoriteFields = data?.favoriteFields.objects ?? [];
  const matches = parseFavoriteRecordFields([record], favoriteFields);
  return Object.keys(matches).sort();
};
